import { BrowserRouter } from 'react-router-dom'
import 'assets/css/app.css'
import store, { persistor } from 'store'
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux'
import { ToastContainer } from 'react-toastify'
import Router from 'route'
import { Axios } from 'components/Loader'

export default function App() {
    return (
        <Provider store={store}>
            <Axios />
            <PersistGate loading={null} persistor={persistor}>
                <BrowserRouter>
                    <ToastContainer />
                    <Router />
                </BrowserRouter>
            </PersistGate>
        </Provider>
    )
}
